const riot = require('riot');

riot.tag2('tooltip-text', '<div class="bg-overlay_tertiary rounded-8 fs10 lh15 p8" ref="tooltip"><span class="text-white white-space-pre word-break-keep">{opts.text}</span></div>', '', '', function(opts) {
});